import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ModalRegistryService {
  private registry: Map<symbol, any> = new Map();

  register(modals: Record<symbol, any>[] | null): void {
    for (const modalBatch of modals ?? []) {
      for (const id of Object.getOwnPropertySymbols(modalBatch)) {
        this.registry.set(id, (modalBatch as any)[id]);
      }
    }
  }

  get(modalIdentifier: symbol): any {
    return this.registry.get(modalIdentifier);
  }
}
